angular.module('app')
    .directive('listMusicians', function() {
        return {
            templateUrl: 'components/directives/list_musicians/view.list_musicians.html',
            controller: 'ListMusiciansController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                musicians: '<musicians',
                navigate: '=',
                favourite: '=',
                private: '=',
                page: '<',
                edit: '@',
            }
        }
    });
